import { render, staticRenderFns } from "./glossarioModal.vue?vue&type=template&id=8963478a&"
import script from "./glossarioModal.vue?vue&type=script&lang=ts&"
export * from "./glossarioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports